import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

// Layout components (not lazy loaded as they're needed immediately)
import LayoutAuth from "~/pages/providerWrapped/auth/LayoutAuth";
import LayoutAuthBeta from "~/pages/providerWrapped/auth/LayoutAuthBeta";

// Lazy load auth pages
const PageForgotPassword = lazy(
  () => import("~/pages/providerWrapped/auth/PageForgotPassword")
);
const PageLogin = lazy(() => import("~/pages/providerWrapped/auth/PageLogin"));
const PageResetPassword = lazy(
  () => import("~/pages/providerWrapped/auth/PageResetPassword")
);

// Landlord Auth Pages
const PageLandlordCreateAccount = lazy(
  () => import("~/pages/providerWrapped/auth/landlord/PageCreateAccount")
);
const PageLandlordLogin = lazy(
  () => import("~/pages/providerWrapped/auth/landlord/PageLogin")
);

// Tenant Auth Pages
const PageTenantCreateAccount = lazy(
  () => import("~/pages/providerWrapped/auth/tenant/PageCreateAccount")
);
const PageTenantLogin = lazy(
  () => import("~/pages/providerWrapped/auth/tenant/PageLogin")
);

// Beta Auth Pages
const PageBetaCreateAccount = lazy(
  () => import("~/pages/providerWrapped/auth/beta/PageCreateAccount")
);

export const authRoutes: RouteObject = {
  Component: LayoutAuth,
  children: [
    // General Auth Routes
    { path: "forgot-password", Component: PageForgotPassword },
    { path: "login", Component: PageLogin },
    { path: "reset-password", Component: PageResetPassword },

    // Landlord Auth Routes
    {
      path: "landlord/create-account",
      Component: PageLandlordCreateAccount,
    },
    { path: "landlord/login", Component: PageLandlordLogin },

    // Tenant Auth Routes
    {
      path: "tenant/create-account",
      Component: PageTenantCreateAccount,
    },
    { path: "tenant/login", Component: PageTenantLogin },
  ],
};

export const betaAuthRoutes: RouteObject = {
  path: "join-beta",
  Component: LayoutAuthBeta,
  children: [{ index: true, Component: PageBetaCreateAccount }],
};
